import { v4 as uuid } from "uuid";

const userData = [
  {
    id: uuid(),
    name: "Amlan",
    lastName: "Saikia",
    houseNo: 1,
    address: "Borghat",
    city: "Nagaon",
    state: "Assam",
    phone: 8136053957,
  },
];

export { userData };
